import { frontendURL } from '../../../helper/URLHelper';

const CrmKanbanBoard = () => import('./CrmKanbanBoard.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/crm'),
    name: 'crm_kanban',
    meta: {
      permissions: ['administrator', 'agent'],
    },
    component: CrmKanbanBoard,
  },
];
